import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	startDateLabel: {
		id: 'software-deployments.date-filter.date-range-picker.start-date-label',
		defaultMessage: 'Start date',
		description: 'Text field label for selecting the start date',
	},
	endDateLabel: {
		id: 'software-deployments.date-filter.date-range-picker.end-date-label',
		defaultMessage: 'End date',
		description: 'Text field label for selecting the end date',
	},
	invalidDateFormatHelperMessage: {
		id: 'software-deployments.date-filter.date-range-picker.invalid-date-format-helper-message',
		defaultMessage: 'Date format should be YYYY/MM/DD',
		description:
			'Error message informing users that they have typed in a date in an invalid format. Will be displayed as red text underneath the text field',
	},
	invalidDateErrorMessage: {
		id: 'software-deployments.date-filter.date-range-picker.invalid-date-error-message',
		defaultMessage: 'Date invalid',
		description:
			'Error message informing users that they have typed in a date in an invalid format. Will be displayed as red text underneath the text field',
	},
	beforeAprilDateErrorMessage: {
		id: 'software-deployments.date-filter.date-range-picker.before-april-date-error-message',
		defaultMessage: 'Date before April 2020 not allowed',
		description:
			'Error message informing users that selecting a date before April 2020 is not allowed. Will be displayed as red text underneath the text field',
	},
	futureDateErrorMessage: {
		id: 'software-deployments.date-filter.date-range-picker.future-date-error-message',
		defaultMessage: 'Future date not allowed',
		description:
			'Error message informing users that selecting a date after today is not allowed. Will be displayed as red text underneath the text field',
	},
	startDateAfterEndDateErrorMessage: {
		id: 'software-deployments.date-filter.date-range-picker.start-date-after-end-date-error-message',
		defaultMessage: 'Start date must be before end date',
		description:
			'Error message informing users that selecting a date after today is not allowed. Will be displayed as red text underneath the text field',
	},
	dateRangeMoreThanYearApartErrorMessage: {
		id: 'software-deployments.date-filter.date-range-picker.date-range-more-than-year-apart-error-message',
		defaultMessage: 'Date range must be less than a year apart',
		description:
			'Error message informing users that selecting a date after today is not allowed. Will be displayed as red text underneath the text field',
	},
	dateSuccessMessage: {
		id: 'software-deployments.date-filter.date-range-picker.date-success-message',
		defaultMessage: '{dateType} selected',
		description:
			'Validation message show informing users they have successfully typed in a valid date',
	},
	editorSuccessIcon: {
		id: 'software-deployments.date-filter.date-range-picker.editor-success-icon',
		defaultMessage: 'Editor Success Icon',
		description: 'Label describing the editor success message icon',
	},
	errorIcon: {
		id: 'software-deployments.date-filter.date-range-picker.error-icon',
		defaultMessage: 'Error Icon',
		description: 'Label describing the error message icon',
	},
	confirmFormSubmission: {
		id: 'software-deployments.date-filter.date-range-picker.confirm-form-submission',
		defaultMessage: 'Confirm',
		description: 'Button label for confirming form submission',
	},
	cancelFormSubmission: {
		id: 'software-deployments.date-filter.date-range-picker.cancel-form-submission',
		defaultMessage: 'Cancel',
		description: 'Button label for cancelling form submission',
	},
});
